import { Outlet} from "react-router-dom";
import Sidebar from "../../Components/Sidebar/Sidebar";

interface Props {}

const HomePage = (props: Props) => {
  return (
    <div className="flex h-screen overflow-hidden">

      <Sidebar />
      <div className="flex-grow h-full overflow-auto p-4">
        <Outlet />
      </div>
    </div>
  );
};

export default HomePage;
